const literal = <V extends keyof any>(v: V) => v

export { literal }
